export default "__VITE_ASSET__Bqud5AZM__"